import { parseTextAlignAttr } from "../base/helpers";
import cx from "clsx";
export function smallParagraphSpec() {
    return {
        paragraph_small: {
            content: "inline*",
            group: "block",
            defining: true,
            attrs: {
                textAlign: { default: null },
            },
            parseDOM: [
                {
                    tag: "p",
                    getAttrs: (element) => {
                        if (element.classList.contains("paragraph-small")) {
                            return false;
                        }
                        return {
                            textAlign: parseTextAlignAttr(element),
                            size: "small",
                        };
                    },
                },
            ],
            toDOM: (node) => {
                const { textAlign } = node.attrs;
                return [
                    "p",
                    {
                        class: cx("paragraph-small", {
                            [`align-${textAlign}`]: textAlign,
                        }),
                    },
                    0,
                ];
            },
        },
    };
}
